import React from 'react';

import { Page } from 'src/app/components';

const Legals = () => {
  return (
    <Page>
      <Page.Main className="mx-auto max-w-screen-2xl">
        <div style={{ paddingTop: '82px' }}>
          <iframe
            title="Mentions légales"
            src="/equilibre-legals.pdf"
            className="w-full"
            style={{ minHeight: 'calc(100vh - 82px)' }}
          />
        </div>
      </Page.Main>
    </Page>
  );
};

export default Legals;
